var timelineData = {
  name: 'timeline',
  data: [{
    fontFamily: '',
    fontSize: 12,
    border: 2,
    fontColor: '#6a6a6a',
    /* 圆点的中心点颜色和外圈颜色 */
    blueNodeBorderColor: 'rgba(41, 190, 206)',
    blueNodeBgColor: '#0687FF',
    greenNodeBorderColor: 'rgba(31, 194, 187)',
    greenNodeBgColor: '#2DC380',
    redNodeBorderColor: 'rgba(247, 103, 118)',
    redNodeBgColor: '#f00',
    yellowNodeBorderColor: 'rgba(250, 173, 20)',
    yellowNodeBgColor: '#FFBC00',
    originalIcon: true
  }]
};
export default timelineData;